exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sub-btn-div {\r\n    margin-bottom: 0.25em;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/www/kh_indesso_web/src/app/components/category/categories/categories.component.css
// module id = ../../../../../src/app/components/category/categories/categories.component.css
// module chunks = 0